import Vue from 'vue';
import Common from './Common.vue';
import Btn from './Btn.vue';

Vue.component('Common', Common)
Vue.component('Btn', Btn)